"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const textUtils_1 = __importDefault(require("@powerednow/shared/modules/utilities/textUtils"));
const settingsKeys_1 = __importDefault(require("@powerednow/shared/constants/settingsKeys"));
const constants_1 = require("@powerednow/shared/constants");
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const modelLookup_1 = require("../modelLookup");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
// eslint-disable-next-line no-redeclare
class AppointmentType extends complexData_1.default {
    static get allowedAssociations() {
        return {
            bookingDateException: {
                key: 'bookingDateException',
                instance: (0, modelLookup_1.complexFindModel)('BookingDateException'),
                condition: {
                    appointmentTypeId: this.Entity.getFieldSymbols().id,
                },
            },
            company: {
                key: 'company',
                instance: (0, modelLookup_1.complexFindModel)('Company'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().company_id,
                },
            },
        };
    }
    async isDeleteAllowed() {
        const count = (await this.getAllBookingDateException()).length;
        return count === 0;
    }
    async getSymbolizedPriceText() {
        const company = await this.getCompany();
        const currency = await company.getCurrency();
        return textUtils_1.default.formatMoney(this.data.price, currency.data);
    }
    getDurationMinutes() {
        const durationData = constants_1.ACTION.CUSTOM_APPOINTMENT_TYPE.DEFAULT_DURATION.find(defaultDuration => defaultDuration.id === this.dataValues.id);
        return durationData?.value || 0;
    }
    async getCompanyDefaultDuration() {
        const company = await this.getCompany();
        return company.getSettingValue(settingsKeys_1.default.DEFAULT_APPOINTMENT_LENGTH);
    }
    async getDefaultDuration() {
        return this.dataValues.defaultDuration || this.getCompanyDefaultDuration();
    }
}
AppointmentType.Entity = entity_1.default;
AppointmentType.modelProperties = modelProperties_1.default;
exports.default = AppointmentType;
//# sourceMappingURL=../../../../src/models/appointmentType/index.js.map